import React, { useState, useEffect, useCallback } from 'react';
import { TextInput, Selection } from 'components';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import ApiServices from 'services';
import {
  CLIENT_CARE_CHANGE_STATUS_REASON,
  CLIENT_STATUS_ID,
  CLIENT_HOLD_REASON_OPTIONS,
} from 'commons/constants';

const ModalChangeStatus = ({
  clientCareHistoryItem,
  closeModalChangeStatus,
  reloadDataAfterChangeStatus,
}) => {
  const [reason, setReason] = useState('');
  const [selectedReason, setSelectedReason] = useState('');
  const [typeReason, setTypeReason] = useState('');

  useEffect(() => {
    if (clientCareHistoryItem?.clientStatusId === CLIENT_STATUS_ID.ACCEPT_DEAL) {
      setReason('KH không sử dụng dịch vụ');
    }
  }, []);

  const handleSubmit = async () => {
    if (!reason || !clientCareHistoryItem.clientCompanyId) return;

    const dataSend = {
      objClientCompanyPause: {
        reasonForSuspension: reason || '',
        typeSuspensionReason: typeReason ? +typeReason : 0,
      },
    };

    try {
      const res = await ApiServices.updateServiceOff_ChangeStatus_New(
        clientCareHistoryItem.clientCompanyId,
        dataSend,
      );
      if (res?.status === 200) {
        window.UIMessage?.success('Thao tác thành công');
        reloadDataAfterChangeStatus();
      }
    } catch (error) {
      console.log(error);
    }
  };

  function handleChangeReason(event) {
    setReason(event.target.value);
  }

  const handleChangeSelectedReason = useCallback(
    (e, newValue) => {
      const value = e.target.value;
      setSelectedReason(value);
      setTypeReason(value);
    },
    [selectedReason],
  );

  return (
    <Box>
      <Box
        style={{
          marginBottom: '20px',
        }}
      >
        {clientCareHistoryItem?.clientStatusId === CLIENT_STATUS_ID.PROCESSING_DEAL && (
          // <TextInput
          //   required
          //   error={!reason}
          //   helperText={
          //     !reason &&
          //     `Vui lòng nhập ${
          //       CLIENT_CARE_CHANGE_STATUS_REASON[clientCareHistoryItem?.clientStatusId]
          //     }`
          //   }
          //   label={CLIENT_CARE_CHANGE_STATUS_REASON[clientCareHistoryItem?.clientStatusId]}
          //   name="code"
          //   onChange={handleChangeReason}
          //   value={reason}
          // />
          <Selection
            required
            error={!typeReason}
            helperText={!typeReason && `Vui lòng nhập loại tạm ngưng`}
            displayNone={false}
            // label={CLIENT_CARE_CHANGE_STATUS_REASON[clientCareHistoryItem?.clientStatusId]}
            label="Loại tạm ngưng"
            name="selectedReason"
            onChange={handleChangeSelectedReason}
            value={selectedReason}
            dataArrObject={CLIENT_HOLD_REASON_OPTIONS}
          />
        )}

        <TextInput
          required
          multiline
          rows={4}
          error={!reason}
          helperText={
            !reason &&
            `Vui lòng nhập ${
              CLIENT_CARE_CHANGE_STATUS_REASON[clientCareHistoryItem?.clientStatusId]
            }`
          }
          label={CLIENT_CARE_CHANGE_STATUS_REASON[clientCareHistoryItem?.clientStatusId]}
          name="reason"
          onChange={handleChangeReason}
          value={reason}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          marginTop: '10px',
        }}
      >
        <Box sx={{ marginLeft: 'auto', display: 'flex', flexDirection: 'row' }}>
          <BtnCancel onClick={closeModalChangeStatus}>Hủy</BtnCancel>
          <BtnAccept onClick={() => handleSubmit()}>Xác nhận</BtnAccept>
        </Box>
      </Box>
    </Box>
  );
};

export { ModalChangeStatus };

const BtnCancel = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#555',
  opacity: 0.7,
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  '&:hover': {
    backgroundColor: '#555',
    opacity: 0.5,
  },
  padding: '6px 16px 2px 16px',
  textTransform: 'none',
  fontWeight: 'normal',
}));

const BtnAccept = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#13265b',
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  '&:hover': {
    backgroundColor: '#13265b',
    opacity: 0.7,
  },
  padding: '6px 16px 2px 16px',
  textTransform: 'none',
  fontWeight: 'normal',
}));
